<template>
    <BaseModal
        :id="'static-supervisor-modal'"
        :title="title"
        :size="''"
        :message="message"
    >
        <template v-slot:breadcrumb>
            <Breadcrumb :breadcrumb="breadcrumb"/>
        </template>
        <template v-slot:content>
            <form class="col-12 p-0" @submit.prevent="$emit((supervisor_report) ? 'supervisorReport' : 'worksheetsReport', {show_discharge_capability, format_report})">
                <div class="p-0 formdynamic__item col-md-12" :style="`margin-top:20px`">
                    <div  id="1">
                        <label style="display: block" v-html="`1. Do you want to show the discharge capability field?`" class="modal-label mb-3 " for="1"/>
                        <div class="custom-control">
                            <input 
                                type="radio" 
                                class="custom-radio"
                                id="1yes"
                                :value="true"
                                v-model="show_discharge_capability"
                            />
                            <label
                            style="font-size: 0.9rem"
                            :class="'form-check-label radiobutton__text'" v-html="'Yes'"
                                for="1yes"
                            />
                        </div>
                        <div class="custom-control">
                            <input 
                                type="radio" 
                                class="custom-radio"
                                id="1not"
                                :value="false"
                                v-model="show_discharge_capability"
                            />
                            <label
                            style="font-size: 0.9rem"
                            :class="'form-check-label radiobutton__text '" v-html="'No'"
                                for="1not"
                            />
                        </div>
                    </div>
                    <div id="1" class="mt-3">
                        <label style="display: block" v-html="`2. Which format do you want to print the report?`" class="modal-label mb-3 " for="1"/>
                        <div class="custom-control">
                            <input 
                                type="radio" 
                                class="custom-radio"
                                id="PDF-portrait"
                                :value="'portrait'"
                                v-model="format_report"
                            />
                            <label
                            style="font-size: 0.9rem"
                            :class="'form-check-label radiobutton__text'" v-html="'PDF portrait'"
                                for="PDF-portrait"
                            />
                        </div>
                        <div class="custom-control">
                            <input 
                                type="radio" 
                                class="custom-radio"
                                id="PDF-landscape"
                                :value="'landscape'"
                                v-model="format_report"
                            />
                            <label
                            style="font-size: 0.9rem"
                            :class="'form-check-label radiobutton__text '" v-html="'PDF landscape'"
                                for="PDF-landscape"
                            />
                        </div>
                        <div class="custom-control">
                            <input 
                                type="radio" 
                                class="custom-radio"
                                id="xlsx"
                                :value="'xlsx'"
                                v-model="format_report"
                                :disabled="!supervisor_report"
                            />
                            <label
                            style="font-size: 0.9rem"
                            :class="'form-check-label radiobutton__text '" v-html="'xlsx'"
                                for="xlsx"
                            />
                        </div>
                        <div class="custom-control">
                            <input 
                                type="radio" 
                                class="custom-radio"
                                id="csv"
                                :value="'csv'"
                                v-model="format_report"
                                :disabled="!supervisor_report"
                            />
                            <label
                            style="font-size: 0.9rem"
                            :class="'form-check-label radiobutton__text '" v-html="'csv'"
                                for="csv"
                            />
                        </div>
                    </div>
                </div> 
                <CentralLiteButtons save_text="Generate Report"/>
            </form>
        </template>
    </BaseModal>
</template>

<script>

import FormResources    from    './form_resources'
import Breadcrumb       from    '@/components/BreadcrumbComponent/Breadcrumb'
import BaseModal        from    '@/components/BaseModal'
import CentralLiteButtons   from    '@/components/CentralLiteButtons'

export default {

    name:   'SupervisorReportModal',
    props: [
        "title",
        "today",
        "rest_api",
        "notyf",
        "axios",
        "breadcrumb",
        "supervisor_report",
    ],

    components:{
        Breadcrumb,
        BaseModal,
        CentralLiteButtons,
    },

    data(){
        return{
            form_data:                  FormResources.form_data,
            form_format:                FormResources.form_format,
            form_backup:                {...FormResources.form_data},
            message: 'Choose the options that match your preferences.',
            show_discharge_capability: true,
            format_report: 'portrait'
        }
    },

    methods:{
    },

    mounted()
    {
    },
    watch: {
        async 'supervisor_report'()
        {
           this.format_report = 'portrait'
        }
    }
    
}
</script>